import { Component, NgZone, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupuserService } from '../../services/signupuser.service';
@Component({
  selector: 'app-signup-success',
  templateUrl: './signup-success.component.html',
  styleUrl: './signup-success.component.css'
})
export class SignupSuccessComponent {
  @ViewChild('scrollDiv') scrollDiv!: ElementRef<HTMLElement>;
  constructor(private authService: AuthService, private router: Router, private scroller: ViewportScroller,
    private signupService: SignupuserService, private ngZone: NgZone, private spinner: NgxSpinnerService) {
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      document.getElementById("sign-up-success")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    },600);
  }

  ngOnInit() {

    this.spinner.hide();
    if (!localStorage.getItem('issignupsuccess')) {
      this.router.navigate(['/sign-up']);
    }
    localStorage.removeItem('issignupsuccess');
    //this.authService.checkAuthAndRedirect();

  }

}

